export default __webpack_public_path__ + "static/dilan_van_son-3587bd0f258d00f6de2473b0f30a0368.jpg";